<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <!-- or name="fade" -->
      <!-- <router-view :key="key"></router-view> -->
      <router-view />
    </transition>
    <audio id="deviceAlarmSound" style="display: none" loop controls="controls">
      <source
        src="http://uat.qywlsp.com.cn/sound/deviceAlarmSound.mp3"
        type="audio/ogg"
      />
    </audio>
    <audio id="runAlarmSound" style="display: none" loop controls="controls">
      <source
        src="http://uat.qywlsp.com.cn/sound/runAlarmSound.mp3"
        type="audio/ogg"
      />
    </audio>
    <audio id="fireAlarmSound" style="display: none" loop controls="controls">
      <source
        src="http://uat.qywlsp.com.cn/sound/fireAlarmSound.mp3"
        type="audio/ogg"
      />
    </audio>
    <audio id="faultSound" style="display: none" loop controls="controls">
      <source
        src="http://uat.qywlsp.com.cn/sound/faultSound.mp3"
        type="audio/ogg"
      />
    </audio>
    <audio id="linkageSound" style="display: none" loop controls="controls">
      <source
        src="http://uat.qywlsp.com.cn/sound/linkageSound.mp3"
        type="audio/ogg"
      />
    </audio>
    <!--消息通知详情-->
    <information-details
      :informationDialog.sync="informationDialog"
      :informationInfo="informationInfo"
    />
    <!--确认告警弹窗-->
    <confirm-alarm
      :alarmConfirmInfo="alarmConfirmInfo"
      :alarmConfirmDialog.sync="alarmConfirmDialog"
      :confirmAlarmEvent="confirmAlarmEvent"
    />
    <template>
      <confirm-alarm
        v-for="(item, i) in fireAlarmList"
        :key="i"
        :alarmConfirmInfo="item.info"
        :dialogModal="false"
        :dialogTop="'40px'"
        :alarmConfirmDialog.sync="item.dialog"
        :index="i"
        :confirmAlarmEvent="confirmAlarmEvent"
        :fireClose="fireClose"
        :fireStyle="styleList[i]"
      />
    </template>
  </section>
</template>
<script>
import { envInfo } from '@/constants/envInfo'
import { ConfirmAlarm } from '@/views/business/base/history/components'
import {
  getLinkageBySourceCode
} from '@/api/business/base/tenant/linkage'
import {
  findDeviceById,
} from '@/api/business/base/tenant/device'
import store from '@/store/index'
import InformationDetails from "@/components/Information/components/informationDetails";
import {
  updateNotifySignRead
} from '@/api/iori/notify'

export default {
  name: 'AppMain',
  components: {
    InformationDetails,
    ConfirmAlarm
  },
  data() {
    return {
      informationDialog: false,
      informationInfo: null,
      alarmConfirmDialog: false,
      alarmConfirmInfo: null,
      fireAlarmConfirmInfo: null,
      fireAlarmConfirmDialog: false,
      dialogTop: null,
      fireAlarmList: [],
      styleList: [
        { left: '150px', top: '40px' },
        { left: '830px', top: '40px' },
        { left: '150px', top: '420px' },
        { left: '830px', top: '420px' },
      ]
    };
  },
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
    orientationMessage() {
      return this.$store.getters.orientationMessage;
    },
    exportTaskList() {
      return this.$store.getters.exportTaskList;
    },
    alarmTaskList() {
      return this.$store.getters.alarmTaskList;
    },
    alarmMessage() {
      return this.$store.getters.alarmMessage;
    }
  },
  watch: {
    orientationMessage(message) {
      this.orientationNotify(message);
    },
    exportTaskList(notifys) {
      this.exportNotifyList(notifys);
    },
    alarmTaskList(notifys) {
      this.alarmNotifyList(notifys);
    },
    //侦听遥信数据
    alarmMessage(message) {
      this.alarmMessageInfo(message);
    }
  },
  created() {
    // let notifyOb = this.$notifyCom({
    //   title: '火警报警',
    //   message: '00000000'
    // })


    // if (notifyOb != undefined) {
    //   notifyOb.onClick = function () {
    //     console.log('click')
    //   }

    // }
  },
  methods: {
    //   播放音频
    palyAudio(msg) {
      if (msg.alarmType === 3) {
        if (msg.alarmValue == "1.0") {
          let audio = document.getElementById("fireAlarmSound")
          audio.play()
        } else if (msg.alarmValue == "5.0") {
          let audio = document.getElementById("linkageSound")
          audio.play()
        } else if (msg.alarmValue == "2.0") {
          let audio = document.getElementById("faultSound")
          audio.play()
        }
      } else if (msg.alarmType === 1){
        let audio = document.getElementById("runAlarmSound")
        audio.play()
      } else if (msg.alarmType === 2){
        let audio = document.getElementById("deviceAlarmSound")
        audio.play()
      }
    },
    // 结束音频
    pauseAudio(msg) {
      if (msg.alarmType === 3) {
        if (msg.alarmValue == "1.0") {
          let audio = document.getElementById("fireAlarmSound")
          audio.pause()
          audio.load()
        } else if (msg.alarmValue == "5.0") {
          let audio = document.getElementById("linkageSound")
          audio.pause()
          audio.load()
        } else if (msg.alarmValue == "2.0") {
          let audio = document.getElementById("faultSound")
          audio.pause()
          audio.load()
        }
      } else if (msg.alarmType === 1){
        let audio = document.getElementById("runAlarmSound")
        audio.pause()
        audio.load()
      } else if (msg.alarmType === 2){
        let audio = document.getElementById("deviceAlarmSound")
        audio.pause()
        audio.load()
      }

    },
    exportNotifyList(notifys) {
      //取最后一条任务
      let obj = notifys[notifys.length - 1];
      //未发布时才发布通知
      // if (obj != undefined) {
      //     let notifyObj = this.$notify.info({
      //         title: this.$t('commons.info'),
      //         dangerouslyUseHTMLString: true,
      //         message: `<div style="text-align: left;"><i class="el-icon-loading"></i>${obj.taskName}${this.$t('commons.exportInfo.process')}</div><a style="color: #45a0ff;" href="#/personalCenter?id=7">[${this.$t('commons.viewDetails')}]</a>`,
      //         position: 'bottom-right',
      //         duration: 0
      //     });
      //     obj.notifyObj = notifyObj;
      //     store.dispatch("SetExportTask", obj);
      // }
    },
    orientationNotify(message) {//定向消息均有子类型，统一所有定向消息入口
      if (message.messageType == "ExcelImport") {//Excel导入
        this.importExcelNotifyTip(message);
      } else if (message.messageType == "ExcelExport") {//Excel导出
        this.exportExcelNotifyTip(message);
      } else if (message.messageType == 'webNotifyMessage') {//通知
        this.webNotifyMessage(message)
      }
    },
    importExcelNotifyTip(message) {
      if (message.message.importStatus == 2) {//成功
        this.$notify({
          title: this.$t('commons.competed'),
          dangerouslyUseHTMLString: true,
          message: `${message.message.typeId}${this.$t('commons.importInfo.success')}`,
          position: 'bottom-right',
          type: 'success',
        });
      } else if (message.message.importStatus == 4) {//失败
        this.$notify({
          title: this.$t('commons.prompt'),
          dangerouslyUseHTMLString: true,
          message: `<div style="text-align: left;">${message.message.typeId}${this.$t('commons.importInfo.error')}</div><a style="color: #45a0ff;" href="#/personalCenter?id=8">[${this.$t('commons.viewDetails')}]</a>`,
          position: 'bottom-right',
          type: 'error',
        });
      }
    },
    exportExcelNotifyTip(message) {
      //取出所有导出任务
      let exportTaskList = this.$store.getters.exportTaskList;
      for (let i = 0; i < exportTaskList.length; i++) {
        //寻找对应的任务通知
        if (exportTaskList[i].taskId == message.message.taskId) {
          //关闭导出中通知
          exportTaskList[i].notifyObj.close();
          if (message.message.exportFlag == '2') {//完成
            //发布新的通知
            this.$notify({
              title: this.$t('commons.competed'),
              dangerouslyUseHTMLString: true,
              message: `<div style="text-align: left;">${exportTaskList[i].taskName}${this.$t('commons.exportInfo.success')}</div><a style="color: #45a0ff;" href="${envInfo.bgApp[exportTaskList[i].rootPath]}/param/excel/download?dlType=Excel&excelFlag=EXP&excelId=${message.message.taskId}">[${this.$t('commons.clickToDownload')}]</a>`,
              position: 'bottom-right',
              type: 'success',
              duration: 0
            });
          } else if (message.message.exportFlag == 3) {//失败
            //发布新的通知
            this.$notify({
              title: this.$t('commons.prompt'),
              dangerouslyUseHTMLString: true,
              message: `<div style="text-align: left;">${exportTaskList[i].taskName}${this.$t('commons.exportInfo.error')}</div><a style="color: #45a0ff;" href="#/personalCenter?id=7">[${this.$t('commons.viewDetails')}]</a>`,
              position: 'bottom-right',
              type: 'warning',
              duration: 0
            });
          }
          //将当前已处理的通知，在导出任务列表中移除
          store.dispatch("RemoveExportTask", i);
          break;
        }
      }
    },
    webNotifyMessage(message) {
      let notifyObj = this.$notify({
        title: this.ellipsis(message.message.notifyTitle, 15),
        customClass: 'canClickNotify',
        dangerouslyUseHTMLString: true,
        message: this.$t('commons.viewDetails'),
        position: 'bottom-right',
        type: 'info',
        duration: 5000
      });
      // if (message.message.alarmType == 3) {
      //   notifyObj = this.$notify({
      //     title: this.ellipsis(message.message.notifyTitle, 15),
      //     customClass: 'fireNotify',
      //     dangerouslyUseHTMLString: true,
      //     message: this.$t('commons.viewDetails'),
      //     position: 'bottom-right',
      //     type: 'info',
      //     duration: 5000,
      //     onClose: () => {
      //       this.setBottom(0, 1)
      //     }
      //   });
      // }
      let event = this;
      if (notifyObj != undefined) {
        notifyObj.onClick = function () {
          updateNotifySignRead({
            "userAccount": event.$store.getters.userAccount,
            "batchNo": message.message.batchNo
          }).then(() => {
            event.informationDialog = true;
            event.informationInfo = message.message;
            notifyObj.close();
          })
        }
      }
    },
    alarmNotifyList(notifys) {
      //取最后一条告警通知
      let msg = notifys[notifys.length - 1];
      let notifyObj = null;
      //未发布时才发布通知
      if (msg != undefined) {
        let exportTaskList = this.$store.getters.exportTaskList;
        //超过3个告警时，清除一个告警
        if (exportTaskList.length == 3) {
          if (exportTaskList[0].notifyObj != undefined) {
            exportTaskList[0].notifyObj.close();
          }
          store.dispatch("RemoveAlarmTask", 0);
        }
        if (msg.toState != "Normal") {
          if (msg.alarmType === 3) {
            if (msg.alarmValue == "1.0" || msg.presentValue == "1.0") {
              notifyObj = this.$notifyCom({
                title: '火警报警',
                message: this.ellipsis(msg.descName + msg.categoryName + msg.deviceName + this.$t('alarm.alarmNotify') + msg.toState, 33),
              });
              let data = msg
              data.timestamp = this.$moment(new Date(data.timestamp).getTime()).format('YYYY-MM-DD HH:mm:ss');
              if (this.fireAlarmList.length < 4) {
                this.fireAlarmList.push({ info: data, dialog: true })
              } else if (this.fireAlarmList.length === 4) {
                this.fireAlarmList.shift()
                this.fireAlarmList.push({ info: data, dialog: true })
              }
            } else if (msg.alarmValue == "5.0" || msg.presentValue == "5.0") {
              notifyObj = this.$notifyCom({
                title: '联动反馈',
                message: this.ellipsis(msg.descName + msg.categoryName + msg.deviceName + this.$t('alarm.alarmNotify') + msg.toState, 33),
              });
            } else if (msg.alarmValue == "2.0" || msg.presentValue == "2.0") {
              notifyObj = this.$notifyCom({
                title: '故障报警',
                message: this.ellipsis(msg.descName + msg.categoryName + msg.deviceName + this.$t('alarm.alarmNotify') + msg.toState, 33),
              });
            }
          } else {
            notifyObj = this.$notify({
              title: this.$t('alarm.info'),
              customClass: 'canClickNotify',
              message: this.ellipsis(msg.descName + msg.categoryName + msg.deviceName + this.$t('alarm.alarmNotify') + msg.toState, 33),
              position: 'bottom-right',
              duration: 0,
              type: 'warning',
            });

          }
          this.palyAudio(msg)
        } else {
          // notifyObj = this.$notify.info({
          //   title: this.$t('commons.info'),
          //   message: msg.positionName+msg.categoryName+msg.deviceName+this.$t('alarm.recoveryNotify')+msg.toState,
          //   position: 'bottom-right',
          //   duration: 5000,
          // });
        }
        let event = this;
        if (notifyObj != undefined) {
          notifyObj.onClick = function () {
            event.alarmConfirm(msg);
          }
          msg.notifyObj = notifyObj;
          store.dispatch("SetAlarmTask", msg);
        }
      }
    },
    //告警确认
    alarmConfirm(data) {
      if (data.notifyObj != undefined) {
        data.notifyObj.close();
      }
      data.timestamp = this.$moment(new Date(data.timestamp).getTime()).format('YYYY-MM-DD HH:mm:ss');
      this.alarmConfirmInfo = data;
      this.alarmConfirmDialog = true;
      
    },
    confirmAlarmEvent(sourceName, msg) {
      this.pauseAudio(msg)
      let alarmTaskList = this.$store.getters.alarmTaskList;
      let alarmIndex = alarmTaskList.findIndex((item) => {
        return item.sourceName == sourceName;
      })
      if (alarmIndex != -1) {
        store.dispatch("RemoveAlarmTask", alarmIndex);
      }
    },
    fireClose(i) {
      this.fireAlarmList = this.fireAlarmList.filter((v, k) => k != i)
    },
    //告警消息
    alarmMessageInfo(message) {
      let msg = message;
      if (msg.level == 3) {
        let alarmTaskList = this.$store.getters.alarmTaskList;

        let alarmIndex = alarmTaskList.findIndex((item) => {
          return item.sourceName == msg.sourceName;
        })
        if (alarmIndex != -1) {
          if (alarmTaskList[alarmIndex].notifyObj != undefined) {
            alarmTaskList[alarmIndex].notifyObj.close();
          }
          store.dispatch("RemoveAlarmTask", alarmIndex);
        }
        //将告警消息丢入告警通知列表中
        store.dispatch('PushAlarmTaskList', msg);

        if (message.toState != 'Normal') {
          console.log(msg.sourceName)
          // this.linkageHandler(msg.sourceName)
        }
      }
    },
    //严重报警联动处理
    linkageHandler(sourceCode) {
      getLinkageBySourceCode({ "sourceCode": sourceCode }).then(res => {
        if (res) {
          if (res.linkageSourceCode) {
            //联动视频
            findDeviceById({ "deviceId": res.linkageDeviceId }).then(data => {
              this.camera.playVisible = true
              this.camera.playCameraNo = data.deviceEui;
            });
          } else {
            // if(res.linkageValue){
            //     //联动点
            //     setPoint({"sourceCode":res.linkageSourceCode,"value":res.linkageValue});
            // }
          }
        }
      }).catch(error => {
        console.log(`查询失败，原因=> ${error}`)
      })
    },
    ellipsis(value, max) {
      // this.setBottom()
      if (!value) return "";
      if (value.length > max) {
        return value.slice(0, max) + "...";
      }
      return value;
    },
    setBottom(i = 0, k = 0) {
      setTimeout(() => {
        const msgCanList = document.getElementsByClassName('canClickNotify')
        const msgFireList = document.getElementsByClassName('fireNotify')
        console.log(msgCanList.length, msgCanList)
        console.log(msgFireList.length, msgFireList)
        if (msgCanList.length > 0) {
          for (let index = 0; index < msgCanList.length - i; index++) {
            console.log(msgCanList[index])
            msgCanList[index].style.bottom = index * 112 + 16 + 'px'
          }
        }
        if (msgFireList.length > 0) {
          for (let index = 0; index < msgFireList.length - k; index++) {
            console.log(msgFireList[index])
            msgFireList[index].style.bottom = index * 112 + 16 + 'px'
          }
        }
      }, 300)
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  height: calc(100vh - 50px);
  padding-top: 1px;
  padding-bottom: 1px;
  overflow-x: auto;
  overflow-y: auto;
  /* height: 100vh; */
  position: relative;
  /* overflow: hidden; */
}
</style>
